/**
 *
 */




class SpaceAllFactory extends CategFactorable{

	constructor( resultData, or34, CategFactory) {

		super(resultData, or34, CategFactory);

		this._NUM = [ [ 322, 331, 421, 511, 43, 52, 61, 7, 44, 53, 62, 71, 8, 9 ],
				[ 2211, 3111, 222, 321, 411, 33, 42, 51, 6, 322, 331, 421, 511, 43, 52, 61, 7, 44, 53, 62, 71, 8, 9 ] ];
		this._num = this._NUM[this._or34-3];


		this._spaceAllArr = this.makeArray(this._nbSort);
		this._spaceAllDefArr = this.makeArray( this.sortArrayUint8( this._nbDef ) );
		this._spaceAllDefDupArr = this.makeArray(this._nbDefDup);
		//
		this._spaceAll = this.makeJoinArray( this._spaceAllArr );
		this._spaceAllDef = this.makeJoinArray( this._spaceAllDefArr );
		this._spaceAllDefDup = this.makeJoinArray( this._spaceAllDefDupArr );

		this._spaceAllPercent = this.makeCountArray( this._spaceAllDef );

	};

	get num() {   return this._num;   };

	get spaceAllArr() {   return this._spaceAllArr;   };
	get spaceAllDefArr() {   return this._spaceAllDefArr;   };
	get spaceAllDefDupArr() {   return this._spaceAllDefDupArr;   };

	get spaceAll() {   return this._spaceAll;   };
	get spaceAllDef() {   return this._spaceAllDef;   };
	get spaceAllDefDup() {   return this._spaceAllDefDup;   };

	get spaceAllPercent() {   return this._spaceAllPercent;   };



	makeJoinArray(spaceAllArray) {

		let result = [];
		for(let i=0, n=spaceAllArray.length; i<n; i++) {
			let sp = 0;
			for(let j=0, m=spaceAllArray[i].length; j<m; j++) {
				sp+=spaceAllArray[i][j]*Math.pow(10, m-j-1);
			};
			result.push(sp);
		};
		return result;
	};


	//
	makeArray(nbSort) {

		if(arguments.length!==1) {
			throw new Error('引数が不正です( 引数の数 )');
		}else {
			if(!(nbSort instanceof Array) || !(nbSort[0] instanceof Uint8Array || nbSort[0] instanceof Array) || nbSort[0].length !==this._or34) {
				throw new Error('引数が不正です(  引数が二次元配列でないか２次要素数が違います  )');
			}else {
				if(nbSort.length<5) {
					throw new Error('引数の配列１次要素数がが５未満です');
				};

				let boo = false;

				for(let n=nbSort.length, i=n-5; i<n; i++) {
					if( nbSort[i].some(  function(val, ind, arr) {
						let indRt = 0;
						if(ind-1 >= 0) {  indRt = ind-1;  };
						return ( val - arr[indRt] ) < 0;    }) ) {
						boo = true;
						break;
					};
				};
				if(boo) {
					throw new Error('引数が不正です( 配列が昇順ではありません )');
				}
			};
		};

		let spaceAll = [];

		for(let i=0, n=nbSort.length; i<n; i++) {
			let inn = [];
			for(let j=0, m=nbSort[i].length; j<m; j++) {
				if(j<m-1) {
					let aa = nbSort[i][j+1]-nbSort[i][j]-1;
					if(aa > 0) {   inn.push(aa);   };
				}else {
					let aa = nbSort[i][0]+10-nbSort[i][j]-1;
					if(aa > 0) {   inn.push(aa);   };
				};
			};
			let down = MyUtility.copySortUint8( inn, false );
			spaceAll.push(down);
		};
		return spaceAll;
	};


	//   spaceAll count
	makeCountArray(target) {
		let spACt = MyUtility.makeFillArray( this._num.length, 0);
		this.sarchCount(target, this._num, spACt);
		return spACt;
	};


	//
	//  makeBooArray

	getMakeResultBooArray(bit1Arr, bit2Arr, plusNum, isSelect=true) {

		return this.getMakeBooArray( this._spaceAll, bit1Arr, isSelect);
	};

	getMakeDefBooArray(bit1Arr, bit2Arr, isDup=true, isSelect=true) {

		let target = this._spaceAllDef;
		if(! isDup) {   target = this._spaceAllDefDup;   };

		return this.getMakeBooArray(target, bit1Arr, isSelect);
	};

	getMakeBooArray(targetArr, bit1Arr, isSelect=true) {

		let isSelectNum = 1;
		if(! isSelect) {   isSelectNum = 0;   };

		let result = new Uint8Array(targetArr.length);

		for(let i=0, n=targetArr.length; i<n; i++) {
			let count = 0;
			for(let j=0, m=bit1Arr.length; j<m; j++) {
				if(bit1Arr[j]===isSelectNum && this._num[j]===targetArr[i]) {
					result[i] = 1;
				};
			};
		};
		return result;

	};




};














